import store from "@/store";
import { compareVersions, upgradable } from "./packages";
import { getPackageNameVersionAndHash, hasParam, getGroup } from "./mdc";

function isAutoUpgrade(item) {
  return getGroup(item) && item.groupInfo.isAutoUpgrade;
}

function hasAutoUpgrade(item) {
  const packages = store.getters["computerPackage/packageGroup"]({
    p: item,
    filter: (x) => isAutoUpgrade(x),
  });

  if (packages.length !== 0) return getGroup(packages[0]);
  return null;
}

function hasGroup(item) {
  return getGroup(item);
}

function isHigerVersionInstalled(item) {
  const packages = store.getters["computerPackage/packageGroup"]({
    p: item,
    filter: (x) => !isInstallable(x),
  });

  if (packages.length !== 0) {
    const p1NV = getPackageNameVersionAndHash(packages[0]);
    const p2NV = getPackageNameVersionAndHash(item);
    return compareVersions(p1NV.version, p2NV.version) > 0;
  }
  return false;
}

function hasMultipleVersions(item) {
  const packages = store.getters["computerPackage/packageGroup"]({
    p: item,
    filter: (x) => !isUninstallDone(x) && hasParam(x.command.parameters, "-m"),
  });

  return packages.length !== 0;
}

function isInstallable(item) {
  return (
    !item.command ||
    !item.command.name ||
    (item.command &&
      item.command.name == "uninstall" &&
      item.command.status != "failed" &&
      !item.upgradable) ||
    (item.command &&
      item.command.name != "uninstall" &&
      item.command.status == "failed" &&
      !item.upgradable)
  );
}

function isUpgradable(item) {
  if (item.command.name != "upgrade" && item.command.status != "pending") {
    const packages = store.getters["computerPackage/packageGroup"]({
      p: item,
      filter: (x) => !isUninstallDone(x) && x.command.name,
    });

    return (
      !hasMultipleVersions(item) &&
      isInstallable(item) &&
      upgradable(packages, item)
    );
  }
  return false;
}

function isUninstallable(item) {
  return (
    (item.command &&
      item.command.name &&
      item.command.name !== "" &&
      item.command.name !== "uninstall" &&
      item.command.status !== "failed") ||
    (item.command &&
      item.command.name &&
      item.command.name !== "" &&
      item.command.name === "uninstall" &&
      item.command.status === "failed")
  );
}

function isInstallUpgradeDone(item) {
  return (
    item.command &&
    ((item.command.status === "done" && item.command.name === "install") ||
      (item.command.status === "done" && item.command.name === "upgrade"))
  );
}

function isUninstallDone(item) {
  return (
    item.command &&
    item.command.status === "done" &&
    item.command.name === "uninstall"
  );
}

function isWorking(item) {
  return item.command && item.command.status === "working";
}

function hasFailed(item) {
  return item.command && item.command.status === "failed";
}

function isPending(item) {
  return item.command && item.command.status === "pending";
}

export default {
  isInstallUpgradeDone,
  isUninstallDone,
  hasFailed,
  isPending,
  isWorking,
  isInstallable,
  isUninstallable,
  isUpgradable,
  hasMultipleVersions,
  isHigerVersionInstalled,
  isAutoUpgrade,
  hasGroup,
  hasAutoUpgrade,
};
